import React from 'react';
import { ListItem, TextBlock } from '@sato/components';
import { observer } from 'mobx-react-lite';

import { ExternalLink } from '@components/common/Link';
import { ParkingArea, ParkingSpace } from '@models/parking.types';
import { t } from '@stores/localization';
import { isChargerBillingCompanyEParking } from '@views/parking/parking.utils';

type Props = {
  rent: number | undefined;
  parkingSpace: ParkingSpace;
  parkingArea: ParkingArea;
  /**
   * Whether to show eParking info when parking space has electric charger and when
   * billing company is eParking
   */
  showEParkingInfo?: boolean;
};

/** Lists payment information of a rentable parking space */
export const ParkingSpacePaymentsList = observer(
  ({ rent, parkingSpace, parkingArea, showEParkingInfo = false }: Props) => {
    /** Whether parking space electric charger billing company is eParking */
    const isParkingSpaceChargerBillingCompanyEParking =
      showEParkingInfo && isChargerBillingCompanyEParking(parkingArea);

    return (
      <ul>
        {rent && (
          <ListItem horizontal label={t('parking.parking_space_rent')}>
            {`${rent} € / ${t('month_unit')}`}
          </ListItem>
        )}

        {parkingSpace.electricCarCharge && (
          <>
            <ListItem
              horizontal
              label={t('parking.electricity')}
              tooltip={
                isParkingSpaceChargerBillingCompanyEParking
                  ? t('parking.electricity_payment_tooltip')
                  : undefined
              }
            >
              {t('parking.electricity_payment')}
            </ListItem>

            {isParkingSpaceChargerBillingCompanyEParking && (
              <TextBlock className="mt-3" linkComponent={ExternalLink}>
                {t('parking.eParking_text')}
              </TextBlock>
            )}
          </>
        )}
      </ul>
    );
  }
);
